import { PaymentData } from 'src/components/PaymentWidget/payment.type';
import {
  BindPolicyInput,
  PaymentMethod,
  PaymentPlanEnum,
} from 'src/configs/APISchemas/BindPolicy';
import { BillingAddress } from 'src/pages/payment-msi/PaymentMsiV2/types';
import { PurchasePolicyAdditionalData } from 'src/redux/reducer/v2/purchasePolicy';

export type GetBindPolicyMutationSerializerArgs = {
  paymentPlan: PaymentPlanEnum;
  purchasePolicyAdditionalData: PurchasePolicyAdditionalData;
  billingAddress: BillingAddress;
  paymentData: PaymentData;
};

export function getBindPolicyMutationSerializer({
  billingAddress,
  paymentPlan,
  paymentData,
  purchasePolicyAdditionalData,
}: GetBindPolicyMutationSerializerArgs): BindPolicyInput {
  const billingAddressStreet = `${billingAddress.addressLine1} ${
    billingAddress.addressLine2 ?? ''
  }`.trim();

  const bindPolicyBaseInput: Omit<
    BindPolicyInput,
    'paymentMethod' | 'cardData' | 'achData'
  > = {
    paymentPlan,
    applicationId: purchasePolicyAdditionalData.id,
    communityId: String(purchasePolicyAdditionalData.communityId),
    billingAddressCity: billingAddress.city,
    billingAddressState: billingAddress.state,
    billingAddressStreet: billingAddressStreet,
    paymentToken: paymentData.token,
    billingZipCode: billingAddress.zipCode,
  };

  return paymentData.paymentType === 'CC'
    ? {
        ...bindPolicyBaseInput,
        paymentMethod: PaymentMethod.CreditCard,
        cardData: {
          creditCardName: paymentData.cardHolderName,
          creditCardNumber: paymentData.last4Digits,
          creditCardType:
            paymentData.cardType === 'american-express'
              ? 'AMEX'
              : paymentData.cardType,
          creditCardExpirationDate: `${
            paymentData.expiryMonth
          }${paymentData.expiryYear.toString().slice(2)}`,
        },
      }
    : {
        ...bindPolicyBaseInput,
        paymentMethod: PaymentMethod.Ach,
        achData: {
          bankAccountName: paymentData.accountName,
          bankAccountNumber: paymentData.last4Digits,
        },
      };
}
